module.exports = __webpack_public_path__ + "img/rate5.ed73be52.png";